<template>
  <div ref="modal" class="modal" tabindex="-1" role="dialog" @hidden="hidden" id="modal-correo">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <span class="modal-title text-center">
            <b>{{ obj.xtitle }}</b>
          </span>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form class="form-horizontal">
            <div class="form-group">
              <label for="inputEmail3" class="col-sm-2 control-label">De: </label>
              <div class="col-sm-5"><input style="border:0;" type="email" v-model="decorreo" /></div>
              <!-- TODO: EVISAR v-show LA LINE 18 -->
              <div v-show="decorreo != decorreo" class="col-sm-5">
                <input class="form-control input-sm" type="password" v-model="declave" placeholder="Contrasena email" />
              </div>
            </div>
            <div class="form-group">
              <label for="inputEmail3" class="col-sm-2 control-label">Para: </label>
              <div class="col-sm-10"><input style="border:0;" type="email" v-model="obj.xcorreo" /></div>
            </div>

            <div class="form-group">
              <label for="inputEmail3" class="col-sm-2 control-label">Asunto: </label>
              <div class="col-sm-10"><input class="form-control input-sm" type="text" v-model="obj.xasunto" /></div>
            </div>

            <div class="form-group">
              <label for="inputEmail3" class="col-sm-2 control-label">Mensaje: </label>
              <div class="col-sm-10">
                <!-- <ckeditor v-model="obj.xbody" :config="editorConfig"></ckeditor>  -->
                <textarea class="form-control" type="text" v-model="obj.xbody" rows="13"></textarea>
              </div>
            </div>
          </form>

          <p class="text-center text-danger">{{ msg }}</p>
        </div>

        <Alertas ref="alertar" />
        <div v-if="!activo" class="loader center-block"></div>
        <div class="modal-footer">
          <button @click="submit" v-if="activo" type="button" class="btn btn-azul">Enviar</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="css" scoped>
  .loader {
    border: 4px solid #f3f3f3; /* Light grey */
    border-top: 4px solid blue; /* Blue */
    border-bottom: 4px solid blue;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    animation: spin 1.2s linear infinite;
  }
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>

<script>
  import Alertas from '@/components/AAlertas.vue';
  //import https from 'https';

  export default {
    props: {
      obj: {
        // {xid:Number,xtitle:String,xbody:String,all:Boolean,isDefault:Boolean,xsql:Object,xcorreo:String,xasunto:String}
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        decorreo: process.env.VUE_APP_EMAIL_DEFAUL_CORP,
        declave: process.env.VUE_APP_PASSWORD_DEFAUL_CORP,
        activo: true,
        msg: null,
        editorData: '<p>Contenido of the editor.</p>',
        editorConfig: {},
      };
    },
    watch: {
      'obj.xbody': function() {
        if (this.obj.xbody == null) return;
        this.$refs.alertar.reset();
        this.activo = true;
        this.msg = '';
        this.editorData = this.obj.xbody;
        // window.console.log( "MODALLLLLLLLLLLLLLLLll" );
      },
      obj: function() {
        this.$refs.alertar.reset();
        this.activo = true;
      },
    },
    components: { Alertas },
    methods: {
      hidden() {
        this.$refs.alertar.reset();
      },
      submit() {
        var vue = this;
        this.msg = null;
        if (!this.validar()) return;
        this.activo = false;
        /*if (process.env.VUE_APP_NAME == 'ESAM') {
                // ============ discomment only esam portal=======================
                // if( this.decorreo == 'informador@esam.edu.bo' ){ this.declave = 'informador@esam.edu.bo' }
                var correo ={
                    "data": {
                        "sender":{
                            "name": 'Info',
                            "addr": this.decorreo,
                            "password":this.declave,
                        },
                        "reciever":{
                            "name": this.obj.xasunto,
                            "addr": this.obj.xcorreo,
                            "subject": this.obj.xasunto,
                            "msj": this.obj.xbody.replace( "\n"," " ),
                        }
                    }
                }
                var data = JSON.stringify(correo);

                // window.console.log( "CORREITO> ",data )
                // window.console.log( "CORREITO> ",correo )

                var config = {
                    method: 'post',
                    url: process.env.VUE_APP_URL_NOTIFIER_ESAM+'send-notification/',
                    headers: { 'Content-Type': 'application/json' },
                    data : data
                };

                window.axios(config)
                    .then(function (res) {
                        // window.console.log('--------------------- RESPUESTA DEL SERVIDOR --------------------------')
                        const data = res.data
                        window.console.log(res)
                        window.console.log(data)
                        window.console.log( window.stringifyObject(data) )
                        vue.msg = data.message;
                        vue.activo = true;
                    })
                    .catch(function (error) {
                        window.console.error(error)
                        this.msg = error
                        vue.activo = true;
                });
                }else {
                   this.$loadScript("https://smtpjs.com/v3/smtp.js")
                       .then(() => {
                       window.Email &&
                           window.Email.send({
                           Host: process.env.VUE_APP_EMAIL_HOST,
                           Username: this.decorreo,
                           Password: this.depassword,
                           From: this.decorreo,
                           Subject: this.obj.xasunto,
                           To: this.obj.xcorreo, //"kryshot05@gmail.com",
                           Body: this.obj.xbody.replace( "\n"," " ),
                           }).then((message) => {
                               vue.msg = message +': Email enviado a '+this.obj.xcorreo;
                               vue.activo = true;
                           });
                       })
                       .catch((error) => {
                           window.console.log("no llamo el enlace: ", error);
                       });
                    
                //}*/
        window.Email.send({
          Host: 'smtp.gmail.com',
          Username: 'desam@esam.edu.bo',
          Password: 'cilkzzjmidixiser',
          // Username : "info@esam.edu.bo",
          // Password : "ktdhvbhcnahlkveatqv",
          To: this.obj.xcorreo,
          From: vue.decorreo,
          Subject: vue.obj.xasunto,
          Body: this.obj.xbody.replace('\n', ' '),
        }).then((message) => {
          window.console.log(message);
          vue.msg = `${message}: ${vue.obj.xcorreo}`;
          vue.activo = true;
        });
      },
      validar() {
        var cor = this.obj.xcorreo;
        var asu = this.obj.xasunto;
        var men = this.obj.xbody;
        var nom = this.obj.xasunto;
        var valido = true;
        if (!cor) {
          this.msg = 'Falta el correo';
          valido = false;
        } else if (!asu) {
          this.msg = 'Falta el asunto';
          valido = false;
        } else if (!men) {
          this.msg = 'Falta el mensaje';
          valido = false;
        } else if (!nom) {
          this.msg = 'Falta el nombre';
          valido = false;
        }
        return valido;
      },
    },
  };
</script>
